$(function () {
  alignAdCard(9, "center-cell");
  centerBanner();
});

function alignAdCard(val, id) {
  let centerCell = document.getElementById(id);

  if (!centerCell) return;

  let gridCells  = Array.from(document.getElementById('listings-grid').children).filter(isDisplayed);
  let centerIndex = val; //Math.floor((gridCells.length / val) - 1);
  let centerItem = document.getElementById('listings-grid').childNodes[centerIndex];
  if (JSON.parse(centerItem.dataset.promoted)) {
    centerCell.style.display = 'none';
  } else {
    centerItem.replaceChild(centerCell, centerItem.childNodes[0]);
  }
}

function centerBanner() {
  let banner = document.querySelector("section.ad-banner");
  let container = document.getElementById("listings-grid");
  let width = container.clientWidth;
  let position = width >= 992 ? 8 : width >= 767 ? 7 :  width <= 576 ? 8 : 6;
  console.log('width,position', width, position);
  container.insertBefore(banner, container.children[position]);
}

window.onload = function () {
  centerGridCells();
};

function centerGridCells() {
  Array.from(document.getElementsByClassName('center-cell')).forEach((centerCell) => {
    const parentCell = centerCell.parentElement;

    if (!centerCell) return;

    const gridCells = Array.from(parentCell.children).filter(isDisplayed);
    const reduceNumber = gridCells.length < 25 ? 0 : 1;
    const centerIndex = Math.floor((gridCells.length / 2) - reduceNumber);
    const centerItem = parentCell.childNodes[centerIndex];

    centerItem.replaceChild(centerCell, centerItem.childNodes[0]);
  });

  Array.from(document.getElementsByClassName('top-center-cell')).forEach((centerCell) => {
    const parentCell = centerCell.parentElement;

    if (!centerCell) return;

    const gridCells = Array.from(parentCell.children).filter(isDisplayed).slice(0, 5);
    const centerIndex = Math.floor((gridCells.length / 2));
    const centerItem = parentCell.childNodes[centerIndex];

    centerItem.replaceChild(centerCell, centerItem.childNodes[0]);
  });

  Array.from(document.getElementsByClassName('left-center-cell')).forEach((centerCell) => {
    const parentCell = centerCell.parentElement;

    if (!centerCell) return;

    const index = Array.from(parentCell.children).length < 12 ? 6 : 11;
    const centerItem = parentCell.childNodes[index];

    centerItem.replaceChild(centerCell, centerItem.childNodes[0]);
  });
}

function isDisplayed(el) {
  let style = window.getComputedStyle(el);

  return (style.display !== 'none' && el.classList.value.includes('own-grid'));
}



// WEBPACK FOOTER //
// ./app/webpacker/src/js/homepage.js